export default {
    'Menu': 'Меню'
};
